import { defineStore, acceptHMRUpdate } from 'pinia';

const store = defineStore('UserOptions', {
  state: () => ({
    userOptions: {},
  }),
  actions: {
    loadUserOptions(params) { // params = { key?, filter? }
      return window.apiSrv.call('useroptions', 'index', params, true).then((response) => {
        _.extend(this.userOptions, response.data.useroptions);
        return this.userOptions;
      });
    },
    loadOption(key) {
      return this.loadUserOptions({ key }).then(userOptions => userOptions[key]);
    },
    getOption(key) {
      return this.userOptions[key];
    },
    setOption(key, value) {
      this.userOptions[key] = value;
    },
    saveUserOption({ key, value }) {
      return window.apiSrv.call('useroptions', 'update', { id: key, value });
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
